import { Component } from '@angular/core';
import { environment } from '../environments/environment';

@Component({
  selector: 'ccc-cca-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'ccc-org-admin-front';
  version = environment.version;
  lstUpd = environment.lstUpd;

  constructor(
  ) {}

}
